// now In UI part we need show center address once see figma  

import React, { useState, useEffect } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useParams } from "react-router-dom";

function Appointments() {
    const { fetchUserAddress } = useAuthContext();
    const { userId } = useParams();

    const [addresses, setAddresses] = useState([]); // Store fetched addresses
    const [userSlot, setUserSlot] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(0);
    const [selectedDateIndex, setSelectedDateIndex] = useState(0);
    const [selectedTimeIndex, setSelectedTimeIndex] = useState(null);
    const [userAddresses, setUserAddresses] = useState([]);
    const daysofWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    useEffect(() => {
        const loadUserAddress = async () => {
            try {
                const address = await fetchUserAddress(); // This returns a string or object
                // Ensure we have it in array format for mapping
                const addressArray = Array.isArray(address) ? address : [{ address }];
                setAddresses(addressArray);
            } catch (error) {
                console.error("Error loading address:", error);
            }
        };
        loadUserAddress();
    }, [fetchUserAddress]);

    const generateAvailableSlots = () => {
        let today = new Date();
        const slotsByDate = [];

        if (today.getHours() >= 20) {
            today.setDate(today.getDate() + 1);
            today.setHours(10, 0, 0, 0);
        }

        for (let i = 0; i < 14; i++) {
            let currentDate = new Date(today);
            currentDate.setDate(today.getDate() + i);

            let endTime = new Date(currentDate);
            endTime.setHours(20, 0, 0, 0);

            if (i === 0) {
                currentDate.setHours(Math.max(currentDate.getHours() + 1, 10));
                currentDate.setMinutes(0);
            } else {
                currentDate.setHours(10, 0, 0, 0);
            }

            const timeSlots = [];
            while (currentDate < endTime) {
                const formattedTime = currentDate.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                });

                timeSlots.push({
                    time: formattedTime,
                    dateTime: new Date(currentDate),
                });

                currentDate.setMinutes(currentDate.getMinutes() + 30);
            }

            slotsByDate.push({
                date: new Date(today.getFullYear(), today.getMonth(), today.getDate() + i),
                slots: timeSlots,
            });
        }

        setUserSlot(slotsByDate);
    };

    useEffect(() => {
        if (addresses.length > 0) {
            generateAvailableSlots();
        }
    }, [addresses]);

    useEffect(() => {
        const loadAddresses = async () => {
            const address = await fetchUserAddress();
            setUserAddresses([address]); // store in array form
        };
        loadAddresses();
    }, [fetchUserAddress]);

    return (
        <div className="max-w-3xl mx-auto border border-blue-300 rounded-lg p-4 space-y-6">
            {/* Tab Buttons */}
            <div className="flex gap-2">
                <button className="px-4 py-2 border border-blue-500 rounded-full font-medium text-blue-600 bg-white">
                    Home Collection
                </button>
                <button className="px-4 py-2 rounded-full font-medium text-white bg-gradient-to-r from-blue-500 to-blue-700 shadow-md">
                    Visit Nearest Center
                </button>
            </div>

            {/* Address Selection */}
            <div className="space-y-3">
                {addresses.map((addr, idx) => (
                    <label key={idx} className="flex items-start gap-2">
                        <input
                            type="radio"
                            name="address"
                            checked={selectedAddress === idx}
                            onChange={() => setSelectedAddress(idx)}
                            className="mt-1"
                        />
                        {/* <span className="text-gray-700 text-sm leading-snug">
                            {addr.address || addr}
                        </span> */}

                        <span className="text-gray-700 text-sm leading-snug">
                            {typeof addr.address === "object"
                                ? Object.values(addr.address).join(", ")
                                : addr.address}
                        </span>

                    </label>
                ))}
            </div>

            {/* Date Selection */}
            <div className="flex gap-4 overflow-x-auto pb-2">
                {userSlot.map((slotDay, idx) => {
                    const dateObj = slotDay.date;
                    const month = dateObj.toLocaleString("default", { month: "short" });
                    const dayNum = dateObj.getDate();
                    const weekday = daysofWeek[dateObj.getDay()];

                    return (
                        <button
                            key={idx}
                            onClick={() => {
                                setSelectedDateIndex(idx);
                                setSelectedTimeIndex(null);
                            }}
                            className={`flex flex-col items-center px-4 py-2 border rounded-lg min-w-[60px] ${selectedDateIndex === idx
                                ? "border-blue-500 text-blue-600"
                                : "border-gray-300 text-gray-600 hover:border-blue-400"
                                }`}
                        >
                            <span className="text-sm">{month}</span>
                            <span className="text-lg font-semibold">{dayNum}</span>
                            <span className="text-xs">{weekday}</span>
                        </button>
                    );
                })}
            </div>

            {/* Time Slot Selection */}
            <div>
                <p className="font-medium text-gray-700 mb-3">Preferred Time Slot</p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
                    {userSlot[selectedDateIndex]?.slots.map((slot, idx) => (
                        <label
                            key={idx}
                            className={`flex items-center gap-2 border rounded-lg px-2 py-1 cursor-pointer ${selectedTimeIndex === idx
                                ? "border-blue-500 text-blue-600"
                                : "border-gray-300 hover:border-blue-400"
                                }`}
                        >
                            <input
                                type="radio"
                                name="time"
                                checked={selectedTimeIndex === idx}
                                onChange={() => setSelectedTimeIndex(idx)}
                            />
                            <span className="text-sm">{slot.time}</span>
                        </label>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Appointments;
